import * as React from 'react';
import { connect } from 'react-redux';
import {setActiveTab} from "../../actions/ui";
import {updateGloop} from "../../actions/update";
import AnimationBlock from "./AnimationBlock";

class ControlsMenuComponent extends React.Component {
	state = {};

	tabs = {
		textcontrol : 'Text',
		color : 'Background',
		customizecontrol : 'Animation',
		soundcontrol : 'Soundtrack',
	}

	constructor(props) {
		super(props);
	}
	
	render() {
		const {ui} = this.props;
		return (
			<div className={'gloop-controls-menu'}>
				{Object.keys(this.tabs).map((key)=>{

					return (<a href={'#'}
					           className={'-gloop-btn-'+ key + (key == ui.activeTab ? ' active' : '')}
					           onClick={(e) => {
					           	if (ui.activeTab == 'textcontrol') {
									e.preventDefault();
									updateGloop({},true);
									setActiveTab(key);
								}
					           	else {
									e.preventDefault();
									setActiveTab(key);
								}
					           	if(key == 'textcontrol'){
					           		updateGloop({},false);
					            }
					           }}

					>{this.tabs[key]}</a>);
				})}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		ui: state.ui
	};
}
const ControlsMenu = connect(mapStateToProps)(ControlsMenuComponent)
export default ControlsMenu;